<template>
    <el-dialog width="520px" title="批量转移" :before-close="handleClickCancel" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="bathTransferVisible" append-to-body>
        <div class="details">
            <el-form size="small" ref="generalForm"   v-loading="loading"
                     label-position="top" :model="generalForm"  :rules="generalFormRules">
                <el-form-item label="转移至" prop="name">
                    <el-popover placement="bottom" trigger="click" v-model="popoverShow" width="472">
                        <el-select :popper-append-to-body="false" class="selectTree" placeholder="请选择分组" readonly slot="reference"  v-model="generalForm.name"></el-select>
                        <div class="tree_wrap">
                            <el-tree :check-on-click-node="true"
                                     :check-strictly="true"
                                     :data="categoryDataList"
                                     :default-expand-all="true"
                                     :expand-on-click-node='false'
                                     :props="{children: 'children',label: 'name'}"
                                     @node-click="handleSelectNode"
                                     node-key="id"
                                     ref="selectTree"
                                     size="mini">
                            </el-tree>
                        </div>
                    </el-popover>
                </el-form-item>

            </el-form>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {GoodsCategoryList,GoodsChangeGroup} from '@/api'
import {mapState} from "vuex";
export default {
    name: 'bathTransfer',
    props: {
        bathTransferVisible: {
            type: Boolean,
            default: false,
        },
        productIds: {
            type: Array,
            default: () => [],
        },

    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            generalForm:{
                name:'',
                id:0,
            },
            generalFormRules:{
                name:[{ required: true, message: '请选择分组', trigger: 'blue'}],
            },
            categoryDataList:[],
            popoverShow:false
        }
    },
    created() {
        this.getCategoryData()

    },
    computed: {

    },
    mounted() {

    },
    methods: {
        handleSelectNode(data, node, nodeData){
            this.generalForm.id = data.id;
            this.generalForm.name = data.name;
            this.popoverShow = false
        },
        getCategoryData(){
            this.loading = true
            GoodsCategoryList({}).then(res => {
                if (res.code === 200) {
                    this.categoryDataList = res.data
                }
                this.loading = false
            })
        },

        handleClickConfirm(){
            this.$refs.generalForm.validate(valid => {
                if (valid) {

                    let postData = {
                        goods_ids:this.productIds,
                        category_id:this.generalForm.id
                    }
                    this.BtnDisabled = true
                    GoodsChangeGroup(postData).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                message: '转移成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.BtnDisabled = false
                                    this.$emit('success')
                                    this.$emit('update:bathTransferVisible', false)
                                }
                            })

                        }else{
                            this.BtnDisabled = false
                        }
                    })
                    console.log(postData);
                }
            })
        },


        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:bathTransferVisible', false)
        },


    },

}
</script>
<style lang="scss" scoped>
.selectTree{
    width: 100%;
    ::v-deep .el-select-dropdown{
        display: none !important;
    }
}
</style>
